import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable()
export abstract class BaseObject implements OnDestroy {
  public loadingState$ = new BehaviorSubject<boolean>(false);
  public errorState$ = new BehaviorSubject<boolean>(false);
  public emptyState$ = new BehaviorSubject<boolean>(false);
  public destroy$: Subject<void> = new Subject();

  public ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
